// extracted by mini-css-extract-plugin
module.exports = {"root":"file-upload-error_root__At6nJ"};